module.exports = __webpack_public_path__ + "media/fonts/Inter-Medium-3f7acfe5.ttf";